collections.service('AssetCollection', [
    function () {

        function AssetCollection(a) {
            var entities = a || [],
                cache = {},
                cacheByName = {},
                cacheNotFound = {},
                lockCache = false;

            this.add = function (item) {
                entities.push(item);
            };

            this.get = function (rule) {
                if (rule && rule.hasOwnProperty('id') && cacheNotFound.hasOwnProperty(rule.id)) {
                    return cacheNotFound[rule.id];
                }
                var lookupKey = JSON.stringify(rule);
                if (rule && rule.hasOwnProperty('s') && cacheNotFound.hasOwnProperty(lookupKey)) {
                    return cacheNotFound[lookupKey];
                }
                if (rule && rule.hasOwnProperty('id') && cache.hasOwnProperty(rule.id)) {
                    return cache[rule.id];
                }
                if (rule && rule.hasOwnProperty('s')) {
                    if (cacheByName.hasOwnProperty(lookupKey)) return cacheByName[lookupKey];
                }
                var result = _.find(entities, rule);
                if (result && !lockCache) {
                    if (rule.hasOwnProperty('id')) cache[rule.id] = result;
                    if (rule.hasOwnProperty('s')) cacheByName[lookupKey] = result;
                    return result;
                } else {
                    //save to 'notfound' cache
                    if (rule.hasOwnProperty('id')) cacheNotFound[rule.id] = null;
                    if (rule.hasOwnProperty('s')) cacheNotFound[lookupKey] = null;
                }
            };

            this.find = function (rule) {
                return _.filter(entities, rule);
            };

            this.findBy = function(rule, comparator, sort) {
                var items = _.chain(entities)
                    .filter(rule)
                    .filter(comparator);

                var result = sort ? items.orderBy(sort.field, sort.dir) : items;
                return result.value();
            };

            this.sort = function (rule) {
                return _.orderBy(entities, rule);
            };

            this.remove = function (rule) {
                return _.remove(entities, rule);
            };

            this.getAll = function () {
                return entities;
            };

            this.length = function () {
                return entities.length;
            };

            this.fill = function (data) {
                entities = data;
            };

            this.clear = function () {
                lockCache = true;

                entities.forEach(function (item) {
                    if (item.clear() === 'function') {
                        item.clear();
                    }
                });

                entities = [];
                cache = {};
                cacheByName = {};
                cacheNotFound = {};
            }
        }

        return AssetCollection;
    }]);
